import React from 'react';
import { PlayerEventAnalysis as PlayerEventAnalysisData } from '@/services/api';
import PitchZoneMap from './PitchZoneMap';
import MiniStat from './MiniStat';
import ThirdBar from './ThirdBar';

type ZoneMap = Record<string, { count: number; label?: string; color: string; opacity: number }>;

const DefensiveSection: React.FC<{
  defensive: PlayerEventAnalysisData['defensive'];
  defZoneMap: ZoneMap;
}> = ({ defensive, defZoneMap }) => (
  <div className="mb-6">
    <h5 className="text-sm font-semibold text-gray-800 dark:text-gray-200 mb-3">Defensive</h5>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {Object.keys(defZoneMap).length > 0 && (
        <PitchZoneMap zones={defZoneMap} title="Defensive Actions by Zone" />
      )}

      <div>
        <div className="grid grid-cols-2 gap-3 mb-3">
          <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-3 text-center">
            <div className="text-lg font-bold text-gray-900 dark:text-gray-100">
              {defensive.groundDuels.won}/{defensive.groundDuels.total}
            </div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              Ground Duels ({defensive.groundDuels.winRate.toFixed(0)}%)
            </div>
          </div>
          <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-3 text-center">
            <div className="text-lg font-bold text-gray-900 dark:text-gray-100">
              {defensive.aerialDuels.won}/{defensive.aerialDuels.total}
            </div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              Aerial Duels ({defensive.aerialDuels.winRate.toFixed(0)}%)
            </div>
          </div>
          <MiniStat label="Interceptions" value={defensive.interceptions} />
          <MiniStat label="Clearances" value={defensive.clearances} />
        </div>

        {/* Recoveries by third */}
        {defensive.recoveries.total > 0 && (
          <div className="mb-3">
            <p className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
              Recoveries ({defensive.recoveries.total})
            </p>
            <div className="flex gap-2">
              <ThirdBar label="Def" value={defensive.recoveries.defThird} total={defensive.recoveries.total} color="bg-red-400 dark:bg-red-500" />
              <ThirdBar label="Mid" value={defensive.recoveries.midThird} total={defensive.recoveries.total} color="bg-yellow-400 dark:bg-yellow-500" />
              <ThirdBar label="Att" value={defensive.recoveries.attThird} total={defensive.recoveries.total} color="bg-green-400 dark:bg-green-500" />
            </div>
          </div>
        )}

        {/* Discipline */}
        <div className="flex gap-4 text-xs text-gray-600 dark:text-gray-400">
          {defensive.yellowCards > 0 && (
            <span className="flex items-center gap-1">
              <span className="inline-block w-3 h-4 bg-yellow-400 rounded-sm" />
              {defensive.yellowCards}
            </span>
          )}
          {defensive.redCards > 0 && (
            <span className="flex items-center gap-1">
              <span className="inline-block w-3 h-4 bg-red-500 rounded-sm" />
              {defensive.redCards}
            </span>
          )}
          {defensive.fouls > 0 && <span>Fouls: {defensive.fouls}</span>}
          {defensive.foulsSuffered > 0 && <span>Fouled: {defensive.foulsSuffered}</span>}
        </div>
      </div>
    </div>
  </div>
);

export default DefensiveSection;
